<template>
  <div
    style="
      padding: 0rem 2rem;
      width: 100%;
      height: calc(100% - 9.5rem);
      position: absolute;
    "
  >
    <div style="height: 20%" class="w-100 d-flex justify-content-between">
      <div
        v-for="(a, index) in topCardData"
        :key="index"
        style="width: 32.6%; height: 100%; min-width: 36.25rem"
        class="h-100 cardCss d-flex"
      >
        <div
          class="d-flex flex-wrap align-items-center align-content-between"
          style="height: 100%; width: 50%"
        >
          <div class="w-100 d-flex align-items-center">
            <img
              v-show="index == 0"
              style="width: 1.375rem; height: 1.375rem"
              src="@/assets/images/dashboard/setting.png"
              alt=""
            />
            <img
              v-show="index == 1"
              style="width: 1.375rem; height: 1.375rem"
              src="@/assets/images/dashboard/line.png"
              alt=""
            />
            <img
              v-show="index == 2"
              style="width: 1.375rem; height: 1.375rem"
              src="@/assets/images/dashboard/loading.png"
              alt=""
            />
            <div
              style="font-size: 1.25rem; color: #b6b7bc; font-weight: 400"
              class="ms-2"
            >
              {{
                [
                  $t("overview_static.device_overview_page.device_amount"),
                  "IoT Activated",
                  "IoT Ready",
                ][index]
              }}
            </div>
          </div>

          <div
            class="w-100 text-white fw-bold ms-4 d-flex"
            style="font-size: 2rem; padding-left: 1.375rem"
          >
            <div>
              {{ a.count
              }}{{ $t('overview_static.device_overview_page["台"]') }}
            </div>
            <div v-show="index == 1 || index == 2" class="ms-4">
              <div>
                {{
                  (
                    (topCardData[index].count / topCardData[0].count) *
                    100
                  ).toFixed(2)
                }}%
              </div>
              <div style="font-size: 0.75rem; font-weight: 300">
                ({{
                  $t("overview_static.device_overview_page['占所有设备量比']")
                }})
              </div>
            </div>
          </div>
          <div class="w-100 d-flex" v-if="index==1">
            <div class="d-flex ms-4" style="padding-left: 1.375rem">
              <div>{{topCardData[1].online_count}}{{ $t('overview_static.device_overview_page.台') }}</div>
              <div class="ps-1 pe-1 ms-1" style="color:#2dfb20;background-color:rgba(45, 251, 47,0.2) ;border-radius: 4px;">{{ $t('overview_static.customer_page.online') }}</div>
              <div class="ms-2">{{topCardData[1].offline_count}}{{ $t('overview_static.device_overview_page.台') }}</div>
              <div class="ps-1 pe-1 ms-1" style="background-color:rgba(213, 215, 217,0.2) ;border-radius: 4px;">{{ $t('overview_static.customer_page.offline') }}</div>
            </div>
          </div>
          <div></div>
        </div>
        <div
          class="container d-flex flex-wrap align-content-center"
          style="width: 50%; padding-left: 15%"
        >
          <div class="d-flex align-items-end">
            <div style="font-size: 2rem; line-height: 2rem">
              {{ a.year_count
              }}{{ $t('overview_static.device_overview_page["台"]') }}
            </div>
            <div style="font-size: 0.75rem; font-weight: 300">
              {{ $t("今年") }}
            </div>
          </div>
          <div
            class="w-100 d-flex justify-content-start align-items-center mt-2"
            style="position: relative; min-width: 270px"
          >
            <img
              style="width: 2.0625rem; height: 0.9375rem"
              :src="
                Number(a.yoy && a.yoy.rate) > 0
                  ? require('../../assets/images/equipmentDashboard/up.png')
                  : require('../../assets/images/equipmentDashboard/down.png')
              "
              alt=""
            />
            <div
              class="ms-2"
              style="font-size: 1.1rem; font-weight: 600"
              :style="{
                color: Number(a.yoy && a.yoy.rate) > 0 ? '#11cabe' : '#F77474',
              }"
            >
              {{ Number(a.yoy&&a.yoy.rate && a.yoy.rate).toFixed(2) }} %
            </div>
          </div>
          <div class="w-100 mt-2" style="font-size: 0.75rem; font-weight: 300">
            {{
              a.yoy && a.yoy.rate && (a.yoy&&a.yoy.value) > 0
                ? "+" + (a.yoy&&a.yoy.value)
                : (a.yoy&&a.yoy.value)
            }}{{ $t('overview_static.device_overview_page["台"]') }}
            {{ $t("overview_static.work_order_page.compared_to_last_year") }}
          </div>
        </div>
      </div>
    </div>
    <div style="margin-top: 1rem; width: 100%; height: 52%">
      <div class="d-flex w-100 h-100 justify-content-between">
        <div
          style="width: 59%; height: 100%; max-height: 37.5rem"
          class="cardCss position-relative"
        >
          <div class="w-100 d-flex align-items-center justify-content-between">
            <div style="font-size: 1rem; font-weight: 700">
              {{
                $t(
                  "overview_static.device_overview_page.device_distribution_on_industry"
                )
              }}
            </div>

            <div
              class="d-flex align-items-center"
              style="color: #7abdff; font-size: 1.2rem; font-weight: 500"
            >
              <div class="me-2 fs-12">
                {{ $t("overview_static.common.time") }}
              </div>
              <div
                id="flatDate"
                class="input-group"
                style="width: 33%; min-width: 12.5rem"
              >
                <flat-pickr
                  placeholder="Select Documentation Date"
                  v-model="repairDate1"
                  :config="startDateConfig"
                  class="form-control flatpickr-input border-0 ps-0 pe-0 fs-13 bg-0"
                  style="color: #ffffff99; background: #ffffff00"
                  id="documentation_datepicker"
                  @change="getDeviceProductIndustry"
                ></flat-pickr>
                <i
                  data-toggle
                  class="ri-arrow-down-s-line fa fa-calendar mt-1"
                  style="color: #b6b7bc"
                ></i>
              </div>
            </div>
          </div>

          <div id="industryStatistics" style="width: 100%; height: 90%"></div>
        </div>
        <div
          style="width: 40%; height: 100%; max-height: 37.5rem"
          class="cardCss"
        >
          <div class="w-100 d-flex align-items-center justify-content-between">
            <div style="font-size: 1rem; font-weight: 700">
              {{ $t("overview_static.device_overview_page.device_category") }}
            </div>
            <div
              class="d-flex align-items-center"
              style="color: #7abdff; font-size: 1.2rem; font-weight: 500"
            >
              <div class="me-2 fs-12">
                {{ $t("overview_static.common.time") }}
              </div>
              <div
                id="flatDate"
                class="input-group"
                style="width: 33%; min-width: 12.5rem"
              >
                <flat-pickr
                  placeholder="Select Documentation Date"
                  v-model="repairDate2"
                  :config="startDateConfig"
                  class="form-control flatpickr-input border-0 ps-0 pe-0 fs-13 bg-0"
                  style="color: #ffffff99; background: #ffffff00"
                  id="documentation_datepicker"
                  @change="getDeviceProduct"
                ></flat-pickr>
                <i
                  data-toggle
                  class="ri-arrow-down-s-line fa fa-calendar mt-1"
                  style="color: #b6b7bc"
                ></i>
              </div>
            </div>
          </div>
          <!-- 设备类型统计 -->
          <div class="w-100 d-flex" style="height: 90%">
            <div
              id="deviceTypeStatistics"
              style="width: 100%; height: 100%"
            ></div>
            <!--              <div-->
            <!--                  v-if="false"-->
            <!--                style="width: 20%; height: 100%"-->
            <!--                class="d-flex align-items-end"-->
            <!--              >-->
            <!--                <div-->
            <!--                  class="btnClass"-->
            <!--                  style="width:5.625rem;text-align:center;line-height:1.25rem;height: 1.25rem;"-->
            <!--                >-->
            <!--                  {{ $t("overview_static.common.details") }}-->
            <!--                </div>-->
            <!--              </div>-->
          </div>
        </div>
      </div>
    </div>
    <div style="margin-top: 1rem; height: 25%; width: 100%">
      <div class="d-flex w-100 h-100 justify-content-between">
        <div
          style="width: 32.5%; height: 100%; min-height: 15.625rem"
          class="cardCss d-flex flex-wrap align-content-between"
        >
          <div class="w-100 d-flex align-items-center justify-content-between">
            <div style="font-size: 1rem; font-weight: 700">
              {{
                $t(
                  "overview_static.device_overview_page.main_category_distribtion_on_industry"
                )
              }}
            </div>
            <div
              class="d-flex align-items-center"
              style="color: #7abdff; font-size: 1.2rem; font-weight: 500"
            >
              <div class="me-2 fs-12">
                {{ $t("overview_static.common.time") }}
              </div>
              <div
                id="flatDate"
                class="input-group"
                style="width: 33%; min-width: 12.5rem"
              >
                <flat-pickr
                  placeholder="Select Documentation Date"
                  v-model="repairDate3"
                  :config="startDateConfig"
                  class="form-control flatpickr-input border-0 ps-0 pe-0 fs-13 bg-0"
                  style="color: #ffffff99; background: #ffffff00"
                  id="documentation_datepicker"
                  @change="getDeviceIndustryProduct"
                ></flat-pickr>
                <i
                  data-toggle
                  class="ri-arrow-down-s-line fa fa-calendar mt-1"
                  style="color: #b6b7bc"
                ></i>
              </div>
            </div>
          </div>

          <div
            id="industryStatisticsBar"
            style="width: 100%; height: 85%"
          ></div>
          <!--            <div v-if="false" class="w-100 mt-1 pe-5 d-flex justify-content-end">-->
          <!--              <div-->
          <!--                class="btnClass"-->
          <!--                style="width:5.625rem;text-align:center;line-height:1.25rem;height: 1.25rem;"-->
          <!--              >-->
          <!--                {{ $t("overview_static.common.details") }}-->
          <!--              </div>-->
          <!--            </div>-->
        </div>
        <div
          style="width: 32.5%; height: 100%; min-height: 15.625rem"
          class="h-100 cardCss d-flex flex-wrap align-content-between"
        >
          <div class="w-100 d-flex align-items-center justify-content-between">
            <div style="font-size: 1rem; font-weight: 700">
              {{ $t("overview_dynamic['设备数量统计']") }}
            </div>
            <div
              class="d-flex align-items-center"
              style="color: #7abdff; font-size: 1.2rem; font-weight: 500"
            >
              <div class="me-2 fs-12">
                {{ $t("overview_static.common.time") }}
              </div>
              <div
                id="flatDate"
                class="input-group"
                style="width: 33%; min-width: 12.5rem"
              >
                <flat-pickr
                  placeholder="Select Documentation Date"
                  v-model="repairDate4"
                  :config="startDateConfig"
                  class="form-control flatpickr-input border-0 ps-0 pe-0 fs-13 bg-0"
                  style="color: #ffffff99; background: #ffffff00"
                  id="documentation_datepicker"
                  @change="getAmountTrendEvent('amount')"
                ></flat-pickr>
                <i
                  data-toggle
                  class="ri-arrow-down-s-line fa fa-calendar mt-1"
                  style="color: #b6b7bc"
                ></i>
              </div>
            </div>
          </div>
          <!-- 设备数量统计 -->
          <div
            id="industryStatisticsBar2"
            style="width: 100%; height: 85%"
          ></div>
          <!--            <div v-if="false" class="w-100 mt-1 pe-5 d-flex justify-content-end">-->
          <!--              <div-->
          <!--                class="btnClass"-->
          <!--                style="width:5.625rem;text-align:center;line-height:1.25rem;height: 1.25rem;"-->
          <!--              >-->
          <!--                {{ $t("overview_static.common.details") }}-->
          <!--              </div>-->
          <!--            </div>-->
        </div>
        <div
          style="width: 32.5%; height: 100%; min-height: 15.625rem"
          class="h-100 cardCss d-flex flex-wrap align-content-between"
        >
          <div class="w-100 d-flex align-items-center justify-content-between">
            <div style="font-size: 1rem; font-weight: 700">
              {{ $t("overview_dynamic['IoT状态统计']") }}
            </div>
            <div
              class="d-flex align-items-center"
              style="color: #7abdff; font-size: 1.2rem; font-weight: 500"
            >
              <div class="me-2 fs-12">
                {{ $t("overview_static.common.time") }}
              </div>
              <div
                id="flatDate"
                class="input-group"
                style="width: 33%; min-width: 12.5rem"
              >
                <flat-pickr
                  placeholder="Select Documentation Date"
                  v-model="repairDate5"
                  :config="startDateConfig"
                  class="form-control flatpickr-input border-0 ps-0 pe-0 fs-13 bg-0"
                  style="color: #ffffff99; background: #ffffff00"
                  id="documentation_datepicker"
                  @change="getAmountTrendEvent('iot')"
                ></flat-pickr>
                <i
                  data-toggle
                  class="ri-arrow-down-s-line fa fa-calendar mt-1"
                  style="color: #b6b7bc"
                ></i>
              </div>
            </div>
          </div>
          <!-- IoT状态统计 -->
          <div
            id="industryStatisticsBar3"
            style="width: 100%; height: 85%"
          ></div>
          <!--            <div v-if="false" class="w-100 mt-1 pe-5 d-flex justify-content-end">-->
          <!--              <div-->
          <!--                class="btnClass"-->
          <!--                style="width:5.625rem;text-align:center;line-height:1.25rem;height: 1.25rem;"-->
          <!--              >-->
          <!--                {{ $t("overview_static.common.details") }}-->
          <!--              </div>-->
          <!--            </div>-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  deviceTypeStatisticsEcharts,
  industryStatisticsEcharts,
  industryStatisticsBarEcharts,
  lineEchart,
  lineEchartIot,
} from "@/utils/equipmentDashboard";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { API_SVC_HOST } from "@/config/common";

import moment from "moment";
import {
  deviceProductIndustry,
  deviceProduct,
  deviceIndustryProduct,
  deviceGrowthRate,
  amountTrend,
} from "@/service/index";
import { ref } from "vue";
import _ from "lodash";

export default {
  setup() {
    const topCardData = ref([
      { count: "", growth_rate: "", yoy: "", scrap_rate: "", year_count: "" },
      { count: "", growth_rate: "", yoy: "", scrap_rate: "", year_count: "",offline_count:"",online_count:"" },
      { count: "", growth_rate: "", yoy: "", scrap_rate: "", year_count: "" },
    ]);
    const nameList = ref(["total", "iot_activated", "iot_ready"]);
    deviceGrowthRate().then((res) => {
      if (res && res.payload) {
        topCardData.value = setData(res.payload);
      }
    });
    function setData(data) {
      var list = [];
      nameList.value.forEach((item) => {
        list.push({ ...data[item] });
      });
      return list;
    }
    return {
      topCardData,
      nameList,
    };
  },
  components: {
    flatPickr,
  },
  data() {
    return {
      startDateConfig: {
        wrap: true,
        altInput: true,
        altFormat: "Y-m-d", //选择时显示的{{$t('overview_static.common.time')}}
        dateFormat: "Y-m-d",
        mode: "range",
        allowInput: true, //是否允许用户直接在输入框中输入日期。
        appendTo: document.getElementById("app"),
      },
      timmer: null,
      timeData: "",
      yearData: "",
      weekData: "",
      fullscreen: false,
      pathType: "equipment-statistics",
      /* moment().subtract(1, "year").format("YYYY-MM-DD") */
      repairDate1:
        "1996-02-29" +
        " " +
        this.$t("base.to").toLowerCase() +
        " " +
        moment().format("YYYY-MM-DD"),
      repairDate2:
        "1996-02-29" +
        " " +
        this.$t("base.to").toLowerCase() +
        " " +
        moment().format("YYYY-MM-DD"),
      repairDate3:
        "1996-02-29" +
        " " +
        this.$t("base.to").toLowerCase() +
        " " +
        moment().format("YYYY-MM-DD"),
      repairDate4:
        "1996-02-29" +
        " " +
        this.$t("base.to").toLowerCase() +
        " " +
        moment().format("YYYY-MM-DD"),
      repairDate5:
        "1996-02-29" +
        " " +
        this.$t("base.to").toLowerCase() +
        " " +
        moment().format("YYYY-MM-DD"),
    };
  },

  methods: {
    //应用行业型号统计
    getDeviceProductIndustry(product) {
      let params = {
        start:
          moment(
            this.repairDate1.split(this.$t("base.to").toLowerCase())[0].trim()
          ).format("YYYY-MM-DD") || "",
        end:
          moment(
            this.repairDate1.split(this.$t("base.to").toLowerCase())[1].trim()
          ).format("YYYY-MM-DD") || "",
        product: product || "",
      };
      deviceProductIndustry(params).then((res) => {
        if (res && res.payload) {
          res.payload.map((item) => {
            item["value"] = item["count"];
            item["name"] =
              this.$t("overview_dynamic.industy_dict." + item.industry) ||
              item.industry;
          });
          industryStatisticsEcharts({
            chartDom: document.getElementById("industryStatistics"),
            dataList: res.payload,
          });
        }
      });
    },
    //设备类型
    getDeviceProduct() {
      let params = {
        start:
          moment(
            this.repairDate2.split(this.$t("base.to").toLowerCase())[0].trim()
          ).format("YYYY-MM-DD") || "",
        end:
          moment(
            this.repairDate2.split(this.$t("base.to").toLowerCase())[1].trim()
          ).format("YYYY-MM-DD") || "",
      };
      deviceProduct(params).then((res) => {
        if (res && res.payload) {
          deviceTypeStatisticsEcharts(
            {
              chartDom: document.getElementById("deviceTypeStatistics"),
              dataList: res.payload,
              unit: this.$t(
                "overview_static.device_overview_page.device_amount"
              ),
              unit2: this.$t('overview_static.common["台"]'),
            },
            this.linkage
          );
        }
      });
    },
    recursionArr(data) {
      let result = [];
      let queue = data;
      while (queue.length > 0) {
        [...queue].forEach((child) => {
          queue.shift();
          result.push(child.id);
          child.children && queue.push(...child.children);
        });
      }
      return result.toString();
    },
    findParent(arr, id) {
      let stock = [];
      let going = true;
      var warker = function (arr, id) {
        arr.forEach((item) => {
          if (!going) return;
          stock.push(item);
          if (item.id == id) {
            going = false;
          } else if (item.children) {
            warker(item.children, id);
          } else {
            stock.pop();
          }
        });
        if (going) stock.pop();
      };
      warker(arr, id);
      return stock;
    },
    linkage(params) {
      if (params.data.name) {
        this.paramsData = params;
      } else {
        if (
          params.data.children &&
          this.findParent(params.data.children, this.paramsData.data.id)[
            this.findParent(params.data.children, this.paramsData.data.id)
              .length - 2
          ]
        ) {
          console.log(
            this.findParent(params.data.children, this.paramsData.data.id)
          );
          this.paramsData.data = this.findParent(
            params.data.children,
            this.paramsData.data.id
          )[
            this.findParent(params.data.children, this.paramsData.data.id)
              .length - 2
          ];
        }
      }

      if (this.paramsData.data && this.paramsData.data.id) {
        this.getDeviceIndustryProduct(
          this.recursionArr([this.paramsData.data])
        );
        this.getAmountTrend(
          this.recursionArr([this.paramsData.data])
        ); /* 设备数量统计 */
        this.getIOTAmountTrend(
          this.recursionArr([this.paramsData.data])
        ); /* IoT状态统计 */
        this.getDeviceProductIndustry(
          this.recursionArr([this.paramsData.data])
        );
      } else {
        this.getDeviceIndustryProduct();
        this.getAmountTrend(); /* 设备数量统计 */
        this.getIOTAmountTrend(); /* IoT状态统计 */
        this.getDeviceProductIndustry();
      }
    },
    //应用行业产品分类
    getDeviceIndustryProduct(product) {
      let params = {
        start:
          moment(
            this.repairDate3.split(this.$t("base.to").toLowerCase())[0].trim()
          ).format("YYYY-MM-DD") || "",
        end:
          moment(
            this.repairDate3.split(this.$t("base.to").toLowerCase())[1].trim()
          ).format("YYYY-MM-DD") || "",
        product: product || "",
      };
      deviceIndustryProduct(params).then((res) => {
        if (res && res.payload) {
          var list = [];
          var nameList = [];
          var data1 = [];
          var data2 = [];
          var data3 = [];
          var data4 = [];
          var data5 = [];
          var num = 1;
          for (var i in res.payload) {
            num++;
            if (num < 13) {
              nameList.push(this.$t("overview_dynamic.industy_dict." + i));
              data1.push(res.payload[i]["液环泵"] || 0);
              data2.push(res.payload[i]["罗茨泵"] || 0);
              data3.push(res.payload[i]["风机"] || 0);
              data4.push(res.payload[i]["干泵"] || 0);
              data5.push(res.payload[i]["其他"] || 0);
            } else {
              break;
            }
          }
          ["液环泵", "罗茨泵", "风机", "干泵", "其他"].map((item) => {
            list.push({
              type: "bar",
              stack: "stack",
              barGap: 0.5,
              barWidth: "50%",
              label: {
                show: false,
                position: "insideTop",
                align: "center",
                formatter: function (param) {
                  return param.value + "%";
                },
              },
              itemStyle: {
                borderRadius: item == "其他" ? [5, 5, 0, 0] : 0,
              },
              data: [],
              name: this.$t("overview_dynamic.device_type_dict." + item),
            });
          });

          list[0].data = data1;
          list[1].data = data2;
          list[2].data = data3;
          list[3].data = data4;
          list[4].data = data5;
          industryStatisticsBarEcharts({
            chartDom: document.getElementById("industryStatisticsBar"),
            dataList: list,
            nameList: nameList,
            language: localStorage.getItem("language"),
          });
        }
      });
    },
    /* 时间控件 */
    getAmountTrendEvent(type) {
      if (type === "amount") {
        /* 设备数量统计 */
        this.getAmountTrend();
      } else {
        /* IoT状态统计 */
        this.getIOTAmountTrend();
      }
    },
    //装机量
    /* 设备数量统计 */
    getAmountTrend(product) {
      let params = {
        start:
          moment(
            this.repairDate4.split(this.$t("base.to").toLowerCase())[0].trim()
          ).format("YYYY-MM-DD") || "",
        end:
          moment(
            this.repairDate4.split(this.$t("base.to").toLowerCase())[1].trim()
          ).format("YYYY-MM-DD") || "",
        product: product || "",
      };
      amountTrend(params).then((res) => {
        if (res && res.payload) {
          var list1 = [];
          var list2 = [];
          var list3 = [];
          var monthList = [];

          for (var i in res.payload) {
            monthList.push(i);
            list1.push(res.payload[i]["New"]);
            list2.push(res.payload[i]["Retired"]);
            list3.push(res.payload[i]["All Alive"]);
          }
          lineEchart({
            chartDom: document.getElementById("industryStatisticsBar2"),
            unit: this.$t('overview_static.common["个"]'),
            monthList: monthList,
            list1: list1,
            list2: list2,
            list3: list3,
            name1: this.$t("overview_dynamic['新增']"),
            name2: this.$t("overview_dynamic['报废']"),
            name3: this.$t("overview_dynamic['在用']"),
          });
        }
      });
    },
    /* IoT状态统计 */
    getIOTAmountTrend(product) {
      let params = {
        start:
          moment(
            this.repairDate5.split(this.$t("base.to").toLowerCase())[0].trim()
          ).format("YYYY-MM-DD") || "",
        end:
          moment(
            this.repairDate5.split(this.$t("base.to").toLowerCase())[1].trim()
          ).format("YYYY-MM-DD") || "",
        product: product || "",
      };
      amountTrend(params).then((res) => {
        if (res && res.payload) {
          var listiot1 = [];
          var listiot2 = [];
          var listiot3 = [];
          var listiot4 = [];
          var monthList = [];

          for (var i in res.payload) {
            monthList.push(i);
            listiot1.push(
              res.payload[i]["IoT Ready"] == "NA"
                ? 0
                : res.payload[i]["IoT Ready"]
            );
            listiot2.push(
              res.payload[i]["IoT Activated"] == "NA"
                ? 0
                : res.payload[i]["IoT Activated"]
            );
            listiot3.push(
              (res.payload[i]["IoT Ready by all"] == "NA"
                ? 0
                : res.payload[i]["IoT Ready by all"]
              ).toFixed(2)
            );
            listiot4.push(
              (res.payload[i]["IoT Activated by all"] == "NA"
                ? 0
                :(res.payload[i]&&res.payload[i]["IoT Activated by all"]||0)
              ).toFixed(2)
            );
          }
          lineEchartIot({
            chartDom: document.getElementById("industryStatisticsBar3"),
            unit: this.$t('overview_static.common["台"]'),
            monthList: monthList,
            list1: listiot1,
            list2: listiot2,
            list3: listiot3,
            list4: listiot4,
            name1:
              "IoT Ready" ||
              this.$t("overview_static.device_overview_page.barcode_attached"),
            name2:
              "IoT Activated" ||
              this.$t(
                "overview_static.device_overview_page.barcode_unattached"
              ),
            name3:
              "IoT Ready by all" ||
              this.$t(
                "overview_static.device_overview_page.unattached_among_all"
              ),
            name4:
              "IoT Activated by all" ||
              this.$t(
                "overview_static.device_overview_page.unattached_among_all"
              ),
          });
        }
      });
    },

    skipPage(path) {
      this.pathType = path;
      this.$router.push("/" + path);
    },
    moment,
    //全屏
    fullele() {
      return (
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement ||
        document.mozFullScreenElement ||
        null
      );
    },

    //判断是否全屏
    isFullScreen() {
      return !!(document.webkitIsFullScreen || this.fullele());
    },
    //退出全屏
    exitFullscreen() {
      this.fullscreen = false;

      if (document.exitFullScreen) {
        document.exitFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    },
    //全屏
    full(ele) {
      if (ele.requestFullscreen) {
        ele.requestFullscreen();
      } else if (ele.mozRequestFullScreen) {
        ele.mozRequestFullScreen();
      } else if (ele.webkitRequestFullscreen) {
        ele.webkitRequestFullscreen();
      } else if (ele.msRequestFullscreen) {
        ele.msRequestFullscreen();
      }
    },
    //切换是否全屏 全屏按钮要执行的方法
    toggleFullScreen() {
      if (this.isFullScreen()) {
        this.exitFullscreen();
      } else {
        this.fullscreen = true;
        this.full(document.getElementById("equpmentDashboard")); //要设置全屏的元素
      }
    },
    changeLang(lang) {
      this.language = lang;
      localStorage.setItem("language", lang);
      // 设置i18n.locale 组件库会按照上面的配置使用对应的文案文件
      // this.$i18n.locale = lang;
      window.location.reload();
    },
    logout() {
      var form = document.getElementById("frm_logout");
      form.action = this.logoutUrl;
      form.submit();
      sessionStorage.setItem("is_logout", "true");
      setTimeout(() => {
        localStorage.clear();
      }, 2000);
    },
  },
  computed: {
    icon() {
      return this.fullscreen ? "ri-fullscreen-exit-line" : "ri-fullscreen-line";
    },
    user() {
      return JSON.parse(localStorage.getItem("user"));
    },
    logoutUrl() {
      return _.trimEnd(_.trim(API_SVC_HOST, '"'), "/") + "/logout";
    },
  },
  mounted() {
    this.getDeviceProductIndustry();
    this.getDeviceProduct();
    this.getDeviceIndustryProduct();
    this.getAmountTrend(); /* 设备数量统计 */
    this.getIOTAmountTrend(); /* IoT状态统计 */
    // tendencyEcharts({
    //   chartDom: document.getElementById("tendencyEchart0"),
    //   type: "0",
    // });
    // tendencyEcharts({ chartDom: document.getElementById("tendencyEchart1") });
    // tendencyEcharts({ chartDom: document.getElementById("tendencyEchart2") });
  },
};
</script>

<style scoped>
.menuActive {
  border-radius: 0.625rem;
  background: linear-gradient(
      180deg,
      rgba(254, 200, 241, 0.9) 0%,
      rgba(237, 146, 215, 0) 40.39%
    ),
    radial-gradient(
      96.63% 140.33% at 76.68% 66.67%,
      rgba(96, 46, 166, 0) 0%,
      rgba(201, 119, 214, 0.5) 100%
    );
  background-blend-mode: overlay, normal;
  /* Sign Up button */
  box-shadow: 0px 0.625rem 0.625rem 0px rgba(0, 0, 0, 0.1),
    0px 0px 0.3125rem 0px #fface4 inset, 0px -0.0625rem 0.5rem 0px #9375b6 inset;
}
.cardCss {
  padding: 0.625rem;
  border-radius: 1.25rem;
  background: linear-gradient(
    152deg,
    rgba(49, 46, 46, 0.4) 0%,
    rgba(69, 68, 65, 0.4) 100%
  );
  box-shadow: 0px 1.25rem 3.8125rem 0px rgba(16, 20, 28, 0.6);
  border-top: 0.0625rem solid #b6b7bc3f;
  border-left: 0.0625rem solid #b6b7bc3f;
  border-right: 0.0625rem solid #b6b7bc3f;
}
.btnClass {
  cursor: pointer;
  border-radius: 0.5rem;
  background: linear-gradient(143deg, #363e52 0%, #2b3242 100%);
  box-shadow: 0.5437rem 0.6062rem 1.15rem 0px rgba(61, 73, 100, 0.3) inset;
}
.clickActive {
  border-radius: 1.4375rem;
  background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 0.3) 0%,
      rgba(255, 255, 255, 0.3) 100%
    ),
    rgba(111, 111, 111, 0.1);
  backdrop-filter: blur(0.3656rem);
}
</style>
